import { render } from "./PopupMenu.vue?vue&type=template&id=6b67fd14&scoped=true&ts=true"
import script from "./PopupMenu.vue?vue&type=script&lang=ts"
export * from "./PopupMenu.vue?vue&type=script&lang=ts"

import "./PopupMenu.vue?vue&type=style&index=0&id=6b67fd14&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b67fd14"]])

export default __exports__